export default {
    APPLICATION_PATH: {
        ROOT: '/',
        COMPLETED: '/success',
        NOCOMPLETED: '/nosuccess',
        ERROR: '/error'
    },
};
